var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Import',{attrs:{"title":"Customer","check_validation":'customer/importcustomervalidation',"url":_vm.url,"items":_vm.items,"show_message":'',"sample_file_name":'sample-customer-data.xlsx',"show_dup_handle":{
      show:true,
      value:0}},on:{"import":_vm.submit,"redirectPage":_vm.redirectPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }